<template>
  <div v-loading="loading">
    <el-card>
      <div>
        <!-- <p>{{routeData.destination}}:{{routeData.named_pup_seq}}</p> -->
        <!-- <h4 v-html="payMessage"></h4>-->
        <s-table
          ref="drafts"
          rowKeyField="id"
          xheightWish="tobottomn"
          :pagging="1000"
          v-model="relDrafts"
          :allwaysEdit="true"
          xedit-disabled="disabled"
          :colDefinitions="colDefinitions"
          modx-processor="transdrafts/multigetlist"
          :r-query="qrelDrafts"
          :lazyLoader="false"
          :addEmptyLine="false"
          @cell-change="handleRelDraft"
          @cell-clicked="goTrans"
          xnewRowData="{rel_class:'ScheduledTrip',tags:routeData.destination,type:'dept',rel_object_id:$route.params.tripid,isincome:false}"
        ></s-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/acc_commons";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [commons],
  // name: "trip-drafts-table",
  props: {
    value: {
      type: Object,
      default: () => {},
    },

    businessId: {
      default: null,
    },
  },
  data() {
    return {
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      loading: false,
      relDrafts: [],
      relRoutes: [],
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // "$route.params.tripid": {
    //   async handler(val, oldval) {
    //     if (!val || val == oldval) return;
    //     this.loading = true;
    //     this.relRoutes = await api.getModxList("vue_route", {
    //       kind: "package",
    //       // mode: "sap_buisness",
    //       sort: "in",
    //       limit: 0,
    //       start: 0,
    //       tripid: val
    //     });
    //     this.loading = false;
    //   },
    //   immediate: true
    // }
  },
  computed: {
    payMessage() {
      if (!this.TransDraft) return;
      var msg =
        "Δεν υπαρχει υπόλοιπο για αυτην την χρεωση (" +
        this.$theMoney(this.TransDraft.cost) +
        ")";

      const bl =
        parseFloat(this.TransDraft.cost) - parseFloat(this.TransDraft.balanse);
      if (bl > 0)
        msg =
          "Το υπολοιπο είναι <strong>" +
          this.$theMoney(bl) +
          "</strong> απο " +
          this.$theMoney(this.TransDraft.cost);

      return msg;
    },

    qrelDrafts() {
      _log_(
        ">>$route.query.selectedTrans>>>",
        this.$route.query.selectedTrans
      );
      let qBookings = {
        "Booking.tripid:=": this.$route.params.tripid,
      };
      if (this.$route.params.distributor_select)
        qBookings[
          "Booking.distributor:IN"
        ] = this.$route.params.distributor_select.split(",");

      return {
        limit: 0,
        start: 0,
        selects: ["Booking.distributor as distributor"],
        q_conditions: JSON.stringify(qBookings),
      };
      // if (this.$route.params.tripid)
      //   return {
      //     rel_class: "Booking",
      //     rel_object_id: this.value.id,
      //     limit: 0,
      //     start: 0
      //   };
      // else return null;
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      return [
        // { prop: "transactionId", width: "", editable: false, label: "id" },
        {
          prop: "businessId",
          width: "200px",
          editable: false,
          label: "Tour.Co.",
          placeholder: "...",
          formatter(val, colDefs, row) {
            return (
              '<span class="small_note">' +
              row.business_name +
              "</span>" +
              row.distributor
            );
          },
        },
        {
          prop: "time",
          width: "110px",
          editable: false,
          label: "Date",
          placeholder: "...",
          formatter(val, colDefs, row) {
            if (!val) return "-";

            return vm.dateFromUnxTime(val);
          },
        },
        {
          prop: "title",
          width: "",
          editable: false,
          label: "Brief Description",
          placeholder: "...",
        },
        {
          prop: "transfer_quantity",
          width: "60px",
          editable: false,
          label: "PAX-A",
          placeholder: "...",
          formatter(val, colDefs, row) {
            return val ? val : row.handling_quantity;
          },
        },

        {
          label: "Transf.A",
          prop: "transfer_deptamound",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          label: "Handl.A",
          prop: "handling_deptamound",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "transfer_half_quantity",
          width: "60px",
          editable: false,
          label: "PAX-K",
          placeholder: "...",
          formatter(val, colDefs, row) {
            return val ? val : row.handling_half_quantity;
          },
        },
        {
          label: "Transf.K",
          prop: "transfer_half_deptamound",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          label: "Handl.K",
          prop: "handling_half_deptamound",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "totals_v",
          width: "60px",
          label: "Total",

          formatter(val, colDefs, row) {
            row.transfer_deptamound = row.transfer_deptamound
              ? parseFloat(row.transfer_deptamound)
              : 0;
            row.handling_deptamound = row.handling_deptamound
              ? parseFloat(row.handling_deptamound)
              : 0;
            row.transfer_half_deptamound = row.transfer_half_deptamound
              ? parseFloat(row.transfer_half_deptamound)
              : 0;
            row.handling_half_deptamound = row.handling_half_deptamound
              ? parseFloat(row.handling_half_deptamound)
              : 0;
            return (
              vm.$theMoney(
                row.transfer_deptamound +
                  row.handling_deptamound +
                  row.transfer_half_deptamound +
                  row.handling_half_deptamound
              ) + "&euro;"
            );
            // return row.cost;
          },
        },

        // {
        //   prop: "rel_object_id",
        //   width: "60px",
        //   label: "X",
        //   onlyEditMode: true,
        //   editable: true,
        //   sortable: false,
        //   editorcomponentFactory(row) {
        //     return {
        //       is: "el-button",
        //       icon: "el-icon-top-right",
        //       type: "success",
        //       circle: true,
        //       disabled: !row.id,
        //       title: "Click here for full edit"
        //     };
        //   },
        //   formatter(val, colDefs, row) {
        //     return "-";
        //   }
        // }
      ];
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.loaded = true;

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    init() {},
    goTrans(e) {
      if (e.column.property == "transactionId") {
        if (!e.row.id) {
          return;
        }
        this.routeGo({
          name: "transaction",
          params: {
            transid: e.row.id,
            id: e.row.businessId,
            direction: "out",
            view: "contact",
          },
        });
      }
    },
    async handleRelDraft(data) {
      // _log_("UPPPP..", data);
      // if (!this.TransDraft) return;
      var dr = data.row;
      // dr.exectime = "now";
      // dr.time = "now";
      // dr.businessId = this.TransDraft.businessId;
      // dr.isincome = this.TransDraft.isincome;

      // dr.parentid = this.$route.query.selectedTrans;
      // dr.in = this.$route.params.direction;
      // dr.place = this.TransDraft.place;
      // // dr.isicome = this.$route.params.direction == "in";
      // dr.type = "payment";
      //
      if (dr) {
        const total =
          dr.transfer_deptamound +
          dr.handling_deptamound +
          dr.transfer_half_deptamound +
          dr.handling_half_deptamound;
        _log_("total...", dr, total);
        const isNew = !dr.id;
        dr.cost = total;
        // delete dr.cost;
        const { data } = await api.fetchProcessor("transdrafts/multiupdate", {
          ...dr,
          buildProps: [
            "TRANSFER",
            "HANDLING",
            "TRANSFER-HALF",
            "HANDLING-HALF",
          ],
          hooKrelated: { bookedPrice: total },
        });
        this.$refs.drafts.updateRow(
          { idx: dr.idx },
          { rowId: data.object.rowId }
        );
      }

      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script>
